import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import DeleteConfirmationModal from 'components/DeleteConfirmation/DeleteConfirmationModal';
import {submitDeleteUserAction, submitUndeleteUserAction} from '../../../actions';
import {endDeleteAction} from 'pages/DeleteConfirmation/actions';

const mapStateToProps = ({deleteConfirmation}) => ({
  deleting: deleteConfirmation.deleteChallengeSubmitted,
  modalOpen: deleteConfirmation.deleting,
  resource: deleteConfirmation.deleteResource,
  resourceId: deleteConfirmation.deleteResourceId
});

const mapDispatchToProps = dispatch => bindActionCreators({
  cancel: endDeleteAction,
  deleteUser: submitDeleteUserAction,
  undeleteUser: submitUndeleteUserAction
}, dispatch);

const DeleteUserModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({confirm: props.undelete ? props.undeleteUser : props.deleteUser}))
)(DeleteConfirmationModal);

export default DeleteUserModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/DeleteUserModal/DeleteUserModalContainer.js